import React, { useContext, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { IoCalendarOutline } from 'react-icons/io5';
import { AppContextProvider } from '../../../App';
import { LuChevronDown } from "react-icons/lu";
const generateData = (days) => {
  const data = [];
  const today = new Date();
  
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    data.push({
      date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), // Format as "MMM DD"
      money: Math.floor(Math.random() * 5000) + 500 // Random money value between $500 and $5500
    });
  }
  
  return data;
};

const data30Days = generateData(30);
const data7Days = generateData(7);
const data1Day = generateData(1);

const ChartComponent = ({type}) => {
  const [data, setData] = useState(data30Days);
  const {darkMode} = useContext(AppContextProvider)

  const handleDataChange = (event) => {
    const selectedType = parseInt(event.target.value);
    if (selectedType === 1) {
      setData(data1Day);
    } else if (selectedType === 7) {
      setData(data7Days);
    } else if (selectedType === 30) {
      setData(data30Days);
    }
  };

  const formatYAxis = (tickItem) => {
    return `$${(tickItem / 1000).toFixed(0)}K`; // Format tick labels as $1K, $2K, etc.
  };

  return (
    <div className="p-4  mt-4  bg-[#F0F0F0] px-4 py-3 rounded-lg dark:bg-[#282828] w-full">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-3xl font-semibold">Sales Overview</h1>
        <div className="relative">
          <IoCalendarOutline className="absolute top-1/2 transform -translate-y-1/2 left-3 text-xl " />
          <select
            className=" custom-select bg-transparent border-[#d3d3d3] border-[2px] rounded-lg pl-10 pr-5 py-2"
            onChange={handleDataChange}
          >
            <option value="1">Last 1 Day</option>
            <option value="7">Last 7 Days</option>
            <option value="30">Last 30 Days</option>
          </select>
          <LuChevronDown className='text-xl absolute right-2 top-3'/>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data}>
          <XAxis dataKey="date" tickLine={false} axisLine={false} />
          <YAxis tickFormatter={formatYAxis} tickLine={false} axisLine={false} />
          <Tooltip formatter={(value) => `${value} views`} contentStyle={{ backgroundColor: darkMode ? '#000' : '#fff', color: darkMode ? '#fff' : '#000' }} />
          <Line type={"linear"} dataKey="money" stroke={darkMode ? "#FFF" : "#000"}  strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartComponent;
